import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import brands from '@/store/modules/brands'
import cart from '@/store/modules/cartNew'
import wishlist from '@/store/modules/wishlist'
import filters from '@/store/modules/filters'
import user from '@/store/modules/user'
import category from '@/store/modules/category'
import promotions from '@/store/modules/promotions'
import productselected from '@/store/modules/productselected'
import recentview from '@/store/modules/recentview'
import fasion from '@/store/modules/fasion'
import topselling from '@/store/modules/topselling'
import buynow from '@/store/modules/buynow'
import siteData from '@/store/modules/siteData'
import vendor from '@/store/modules/vendor'
import order from '@/store/modules/order'
import charges from '@/store/modules/charges'

import * as packageData from '../../package.json'

Vue.use(Vuex)
const vuexPersist = new VuexPersist({
	key: 'ecommerce',
	storage: localStorage
})

const { version } = packageData

export const store = new Vuex.Store({
	state: {
		version: ''
	},
	mutations: {
		initialiseStore (state) {
			// Check if the store exists
			if (localStorage.getItem('ecommerce')) {
				const ecommerce = JSON.parse(localStorage.getItem('ecommerce'))
				// Check the version stored against current. If different, don't
				// load the cached version
				const initialState = {
					brands: brands.state,
					cart: cart.state,
					wishlist: wishlist.state,
					filters: filters.state,
					user: user.state,
					category: category.state,
					promotions: promotions.state,
					productselected: productselected.state,
					recentview: recentview.state,
					topselling: topselling.state,
					fasion: fasion.state,
					buynow: buynow.state,
					siteData: siteData.state,
					vendor: vendor.state,
					order: order.state,
					charges: charges.state
				}

				if (ecommerce.version && ecommerce.version === version) {
					this.replaceState(Object.assign(state, ecommerce))
				} else {
					state.version = version
					Object.keys(initialState).forEach((key) => {
						state[key] = initialState[key]
					})
				}
			}
		}
	},
	modules: {
		brands,
		cart,
		wishlist,
		filters,
		user,
		category,
		productselected,
		promotions,
		recentview,
		topselling,
		fasion,
		buynow,
		siteData,
		vendor,
		order,
		charges
	},
	plugins: [vuexPersist.plugin]
})
